export var TagItemStyles = function (props) {
    var theme = props.theme;
    var effects = theme.effects;
    return {
        root: {
            borderRadius: effects.roundedCorner2,
        },
        close: {
            background: 'transparent',
            borderRadius: "0 " + effects.roundedCorner2 + " " + effects.roundedCorner2 + " 0",
        },
    };
};
//# sourceMappingURL=TagPicker.styles.js.map